type PermissionCandidate = string | { name?: string; permission?: string } | null | undefined

const permissionAliasMap: Record<string, string> = {
  order: 'orders',
  'order status': 'orders',
  'order-status': 'orders',
}

const normalizePermissionValue = (permission: string): string => {
  const raw = permission.trim().toLowerCase()
  if (!raw) return ''
  return permissionAliasMap[raw] || raw
}

export const normalizePermissions = (permissions: PermissionCandidate[] | undefined | null): string[] => {
  if (!Array.isArray(permissions)) {
    return []
  }

  const normalized = permissions
    .map((entry) => {
      if (typeof entry === 'string') {
        return normalizePermissionValue(entry)
      }

      if (entry && typeof entry === 'object') {
        const candidate = entry.name || entry.permission || ''
        return normalizePermissionValue(candidate)
      }

      return ''
    })
    .filter(Boolean)

  return Array.from(new Set(normalized))
}

export const hasPermission = (permissions: string[] | undefined | null, requiredPermission: string): boolean => {
  const normalizedPermissions = normalizePermissions(permissions)
  const normalizedRequiredPermission = normalizePermissionValue(requiredPermission)
  return normalizedPermissions.includes(normalizedRequiredPermission)
}

export const resolveEffectivePermissions = (
  userPermissions: PermissionCandidate[] | undefined | null,
  sectionPermissions: PermissionCandidate[] | undefined | null,
): string[] => {
  const normalizedUserPermissions = normalizePermissions(userPermissions)
  if (normalizedUserPermissions.length > 0) {
    return normalizedUserPermissions
  }

  return normalizePermissions(sectionPermissions)
}
